export default "__VITE_ASSET__$oJSHfqH__"